import "./application.css"
import "@hotwired/turbo-rails"
import ahoy from "ahoy.js"
import { initFlowbite } from "flowbite"
import "../controllers"

let pageStartAt = Date.now()
let pageTracked = false
let pageEngagementFlushed = false

function shouldTrackAnalytics() {
  return !window.location.pathname.startsWith("/admin")
}

function currentPageProperties() {
  return {
    path: `${window.location.pathname}${window.location.search}`,
    title: document.title,
    site: document.body?.dataset.analyticsSite
  }
}

function trackPageView() {
  ahoy.track("Viewed page", currentPageProperties())
  pageTracked = true
}

function flushPageEngagement() {
  if (!pageTracked || pageEngagementFlushed) return

  const durationSeconds = Math.round((Date.now() - pageStartAt) / 1000)
  if (durationSeconds < 5) return

  ahoy.track("Engaged page", {
    ...currentPageProperties(),
    duration_seconds: durationSeconds
  })
  pageEngagementFlushed = true
}

function resetPageTracking() {
  pageStartAt = Date.now()
  pageTracked = false
  pageEngagementFlushed = false
}

function initAdsense() {
  document.querySelectorAll("ins.adsbygoogle").forEach((ad) => {
    if (ad.dataset.adsbygoogleStatus) return

    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch (error) {
      console.error("AdSense failed to initialize", error)
    }
  })
}

document.addEventListener("turbo:load", () => {
  resetPageTracking()
  initFlowbite()
  initAdsense()
  if (shouldTrackAnalytics()) {
    trackPageView()
  }
  if (window.turnstile) {
    document.querySelectorAll(".cf-turnstile").forEach(el => {
      if (!el.querySelector("iframe")) {
        window.turnstile.render(el)
      }
    })
  }
})
document.addEventListener("turbo:render", () => initFlowbite())
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("[data-modal-backdrop]").forEach(el => el.remove())
  const modal = document.getElementById("alert-modal")
  if (modal) {
    modal.classList.add("hidden")
    modal.classList.remove("flex")
    modal.setAttribute("aria-hidden", "true")
  }
  document.body.classList.remove("overflow-hidden")
})
document.addEventListener("turbo:before-visit", flushPageEngagement)
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") {
    flushPageEngagement()
  }
})
window.addEventListener("pagehide", flushPageEngagement)
